<template>
  <!-- 购买IG物品弹窗 -->
  <div>
    <el-row style="margin-bottom: 20px">
      <el-select
        style="width: 150px; margin-right: 20px"
        size="small"
        v-model="query.prizeType"
        placeholder="请选择奖品分类"
        @change="getData(1)"
      >
        <el-option :value="1" label="csgo"></el-option>
        <el-option :value="5" label="dota"></el-option>
      </el-select>
      <el-input
        style="width: 200px; margin-right: 20px"
        size="small"
        placeholder="商品名称搜索"
        v-model="query.search_key"
      ></el-input>
      <el-button type="primary" size="small" @click="getData(1)"
        >搜索</el-button
      >
    </el-row>
    <div class="prize-list-wrap" v-loading="loading">
      <ul class="prize-list" v-if="prizeList && prizeList.length > 0">
        <li class="prize-item" v-for="item in prizeList" :key="item.itemId">
          <i
            class="buyIcon el-icon-view"
            title="查看在售列表"
            @click="showigSell(item)"
          ></i>
          <div class="prize_img">
            <img :src="item.icon_url" alt />
          </div>
          <p>
            <span>{{ item.name }}</span>
          </p>
          <p>
            <span>{{ item.market_hash_name }}</span>
          </p>
          <p class="price-box">
            <span v-if="query.prizeType === 1">{{ item.quality_name }}</span>
          </p>
          <p class="price-box">
            <span v-if="item.exterior_name || item.rarity_name">{{
              query.prizeType === 1 ? item.exterior_name : item.rarity_name
            }}</span>
            <span class="price">{{ item.buy_min_price }} 元</span>
          </p>
          <p>数量：{{ item.buy_sale_count }}</p>
        </li>
      </ul>
      <p class="null_tips" v-else>暂无数据</p>

      <!-- IG物品列表底部分页 -->
      <ul class="pagination" v-if="productMeta" title="首页">
        <li
          :class="`home-page ${productMeta.current_page === 1 ? 'active' : ''}`"
          @click="handleIGPageChange(1)"
        >
          首页
        </li>
        <li
          v-if="productMeta.current_page != 1"
          class="item-page previous-page"
          @click="handleIGPageChange(2)"
          title="上一页"
        >
          <i class="el-icon-arrow-left"></i>
        </li>
        <li
          v-if="productMeta.total_pages === 1"
          class="item-page next-page"
          @click="handleIGPageChange(3)"
          title="下一页"
        >
          <i class="el-icon-arrow-right"></i>
        </li>
        <span> 第{{ productMeta.current_page }}页 </span>
      </ul>
    </div>

    <!--IG商品在售列表-->
    <el-dialog
      :visible.sync="sellProductVisible"
      title="IG商品在售列表"
      :close-on-click-modal="false"
      width="1000px"
      @close="closeSellDialog"
      append-to-body
    >
      <div class="prize-list-wrap" v-loading="loadingSellProduct">
        <ul class="prize-list" v-if="prizeSellList && prizeSellList.length > 0">
          <li
            class="prize-item"
            v-for="sellerInfo in prizeSellList"
            :key="sellerInfo.trade_id"
          >
            <div v-if="infos" class="buyIcon">
              <i
                v-if="!buyLock || buyGoodsId != sellerInfo.trade_id"
                class="el-icon-wallet"
                title="购买物品"
                @click="igDeliver(sellerInfo)"
              ></i>
              <i v-else class="el-icon-loading" title="正在请求中..."></i>
            </div>
            <div v-else class="addIcon">
              <i
                class="el-icon-plus"
                title="选择物品"
                @click="addIGGoods(sellerInfo)"
              ></i>
            </div>

            <div class="prize_img">
              <img :src="sellerInfo.icon_url" alt />
            </div>
            <p>
              <span>{{ sellerInfo.name }}</span>
            </p>
            <p>
              <span
                >发货类型:{{
                  sellerInfo.delivery_type === 2 ? "手动发货" : "极速发货"
                }}</span
              >
            </p>
            <p class="price-box">
              <span class="price">{{ sellerInfo.unit_price }}元</span>
            </p>
          </li>
        </ul>
        <p class="null_tips" v-else>暂无数据</p>

        <!-- IG在售物品底部分页 -->
        <ul class="pagination" v-if="sellProductMeta" title="首页">
          <li
            :class="`home-page ${
              sellProductMeta.current_page === 1 ? 'active' : ''
            }`"
            @click="handleIGSellPageChange(1)"
          >
            首页
          </li>
          <li
            v-if="sellProductMeta.current_page != 1"
            class="item-page previous-page"
            @click="handleIGSellPageChange(2)"
            title="上一页"
          >
            <i class="el-icon-arrow-left"></i>
          </li>
          <li
            v-if="sellProductMeta.total_pages === 1"
            class="item-page next-page"
            @click="handleIGSellPageChange(3)"
            title="下一页"
          >
            <i class="el-icon-arrow-right"></i>
          </li>
          <span> 第{{ sellProductMeta.current_page }}页 </span>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  mapState,
  mapActions
} from 'vuex'
import http, { patchData, server, postApiData, getApiData } from '@/http'

export default {
  props: {
    value: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      sellProductVisible: false, //在售列表弹窗显示标志
      loading: false, //饰品列表加载动画
      loadingSellProduct: false, //饰品在售列表加载动画
      buttonLoading: false,//按钮加载动画
      buyLock: false,//防止购买重复点击锁
      buyGoodsId: undefined,//当前被购买物品的id
      query: {//ig物品列表
        page_no: 1,//页标
        search_key: undefined, //物品名称
        prizeType: 1,//奖品分类 1是csgo 5是dota2 ,默认是1
      },
      igSellquery: {//ig在售物品列表
        page_no: 1,
        product_id: undefined, //物品ID
      },
      prizeList: undefined, //饰品列表数据
      prizeSellList: undefined,//饰品售卖列表数据
      productMeta: undefined, //饰品列表底部分页
      sellProductMeta: undefined, //在售列表底部分页
      page: 1,
      sellPage: 1,
    }
  },
  computed: {
    ...mapState({
      boxCategories: (state) => state.data.boxCategories, //箱子分类数据
    }),
    infos: {
      get() {
        //拿到要查询的物品名字
        return this.value
      },
      set() { }
    }
  },
  watch: {
    infos: {
      // 监听传来的订单数据
      immediate: true, //首次监听
      handler: function (val) {
        //执行代码
        if (!val) {
          //不是购买物品而是选择物品时，不会传参进来，就直接查数据
          this.getData(1)//查询数据
        } else {
          //赋值搜索名字
          this.query.search_key = val.shop_prize.name
          this.getData(1)//查询数据
        }
      }
    }
  },
  created() { },
  mounted() { },
  methods: {
    getData(num) {
      //搜索物品
      this.loading = true
      if (num === 1) {
        //当搜索新东西而不是底部换页时，还原页面下标为1
        this.query.page_no = 1
      }

      this.query.app_id = this.query.prizeType === 1 ? 730 : 570
      let params = {
        app_id: this.query.app_id,
        page: this.query.page_no,
        name: this.query.search_key
      }
      getApiData('ig/list',params).then(res => {
        if (res) {
          this.prizeList = res.data.data
          //设置底部导航条数据
          this.productMeta = {
            current_page: res.data.current_page, //当前页标
            total_pages: res.data.total_pages, //是否有下一页 1代表有 0代表无
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    showigSell(rowInfo) {
      //打开在售列表弹窗
      this.sellProductVisible = true
      this.igSellquery.product_id = rowInfo.product_id
      //查询在售列表
      this.getIgSellProduct(rowInfo)
    },
    getIgSellProduct(rowInfo) {
      //获取在售列表数据
      this.loadingSellProduct = true
      this.igSellquery.app_id = this.query.prizeType === 1 ? 730 : 570
      let params = {
        third_type: "ig",
        query: this.igSellquery
      }
      getApiData('/api/admin/third_shop_product', {
        params
      })
        .then(res => {
          //给在售列表所有数据都加上一些需要的字段
          for (let i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i]) {
              res.data.data[i].exterior_name = rowInfo.exterior_name//磨损度
              res.data.data[i].shortName = rowInfo.name//不加磨损度的原名
              res.data.data[i].quality_name = rowInfo.quality_name//暗金
              res.data.data[i].rarity_name = rowInfo.rarity_name//品质
              res.data.data[i].ctg_name = rowInfo.ctg_name//种类
            }
          }
          this.prizeSellList = res.data.data
          //设置底部导航条数据
          this.sellProductMeta = {
            current_page: res.data.current_page, //当前页标
            total_pages: res.data.total_pages, //是否有下一页 1代表有 0代表无
          }
        })
        .finally(() => {
          this.loadingSellProduct = false
        })
    },
    igDeliver(itemInfo) {
      //购买饰品
      if (this.buyLock) {
        //防止重复点击的锁
        this.$message.error("请求正在进行中，请勿重复点击")
        return
      }
      this.buyGoodsId = itemInfo.trade_id//保存当前正在购买的物品的id
      this.buyLock = true//加锁
      postApiData('' + this.extractId, {
        trade_id: itemInfo.trade_id,
        unit_price: itemInfo.unit_price,
      })
        .then(res => {
          this.$message.success('购买成功')
          this.closeSellDialog() //关闭ig在售列表弹窗
          this.closeThirdDialig() //关闭第三方发货弹窗
          // this.$emit("refresh")//刷新列表
          this.buyLock = false//解锁
        }).catch(error => {
          this.buyLock = false//解锁
        })
    },
    addIGGoods(infos) {
      //添加IG商品
      //处理数据格式 1是csgo 5是dota
      let Info = {}
      if (this.query.prizeType === 1) {
        // cago物品属性
        Info = {
          id: infos.trade_id,//物品id
          image: infos.icon_url,//物品图片
          price: infos.unit_price,//物品价格
          completeName: infos.name,//带磨损度的完整名称
          name: infos.shortName,//不带带磨损原名称
          market_hash_name: infos.market_hash_name,//英文名
          secondName: infos.exterior_name,//物品磨损度
          qualityName: infos.quality_name,//物品的暗金
          rarityName: infos.rarity_name,//物品品质
          weaponName: infos.ctg_name,//物品种类
          prize_form: 2, //记录来源 1表示扎比特 2表示IG 3代表机器人
          prize_type: this.query.prizeType, //物品种类 1csgo 5表示dota
        }
      } else {
        //  dota物品属性
        Info = {
          id: infos.trade_id,//物品id
          image: infos.icon_url,//物品图片
          price: infos.unit_price,//物品价格
          name: infos.name,//物品名称
          rarityName: infos.rarity_name,//物品稀有度
          prize_form: 2, //记录来源 1表示扎比特 2表示IG 3代表机器人
          prize_type: this.query.prizeType, //物品种类 1csgo 5表示dota
        }
      }

      this.$emit('callbackInfo', Info)
      this.closeSellDialog() //关闭IG在售列表弹窗
      this.closeThirdDialig()//关闭第三方物品弹窗
    },
    closeThirdDialig() {
      //关闭第三方物品列表弹窗
      this.$emit("close")
      this.query.page_no = 1
      // this.prizeList = []
      // this.prizeSellList = []
    },
    closeSellDialog() {
      // 关闭物品在售列表弹窗
      this.sellProductVisible = false
      this.igSellquery.page_no = 1
    },
    handleIGPageChange(num) {
      //切换物品列表的分页
      switch (num) {
        case 1:
          this.query.page_no = 1;//首页
          break;
        case 2:
          this.query.page_no = this.query.page_no - 1;//上一页
          break;
        case 3:
          this.query.page_no = this.query.page_no + 1;//下一页
          break;
      }
      this.getData()
    },
    handleIGSellPageChange(num) {
      //切换在售列表的分页
      switch (num) {
        case 1:
          this.igSellquery.page_no = 1;//首页
          break;
        case 2:
          this.igSellquery.page_no = this.igSellquery.page_no - 1;//上一页
          break;
        case 3:
          this.igSellquery.page_no = this.igSellquery.page_no + 1;//下一页
          break;
      }
      this.getIgSellProduct()
    }
  }
}

</script>
<style lang="less" scoped>
//IG底部分夜样式
.pagination {
  display: flex;
  align-items: center;
  li {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
    background-color: #f4f4f5;
    color: #606266;
    border-radius: 2px;
    &:hover {
      background-color: #409eff;
      color: #fff;
    }
  }
  .home-page {
    min-width: 40px;
    height: 30px;
    background-color: #f4f4f5;
    color: #606266;
    border-radius: 2px;
    height: 30px;
  }
  .item-page {
    min-width: 30px;
    height: 30px;
  }

  .active {
    background-color: #409eff;
    color: #fff;
  }
}
</style>
